import { Link } from "react-router-dom";
import { Users, ArrowUpRight } from "lucide-react";
import { OPEN_PROBLEMS } from "@/data/openProblems";

const URGENCY_STYLES = {
  Today: "bg-[#FEE2E2] text-[#B91C1C]",
  "This week": "bg-[#FEF3C7] text-[#B45309]",
  "This month": "bg-[#DBEAFE] text-[#1E40AF]",
  "No rush": "bg-[#F3F4F6] text-[#4B5563]",
};

const URGENCY_RANK = { Today: 0, "This week": 1, "This month": 2, "No rush": 3 };

export default function InterestedFeed({ person }) {
  // Match: any of person.categories overlaps with problem.category.
  const matches = OPEN_PROBLEMS.filter((p) =>
    person.categories.includes(p.category)
  ).sort(
    (a, b) =>
      (URGENCY_RANK[a.urgency] ?? 9) - (URGENCY_RANK[b.urgency] ?? 9) ||
      b.datePosted.localeCompare(a.datePosted)
  );

  if (matches.length === 0) return null;

  return (
    <section className="mt-14" data-testid="interested-feed">
      <div className="flex items-baseline justify-between">
        <h2 className="font-display font-bold text-2xl text-[#111827]">
          Open problems for {person.name.split(" ")[0]}
        </h2>
        <Link
          to="/problems"
          className="text-sm font-medium text-[#3FFFB6] hover:text-[#2DE59F]"
        >
          Browse all →
        </Link>
      </div>
      <p className="mt-2 text-[#4B5563] max-w-xl">
        Problems posted by others that match {person.name.split(" ")[0]}'s
        expertise.
      </p>

      <ul className="mt-6 space-y-3">
        {matches.slice(0, 4).map((p) => (
          <li key={p.id}>
            <Link
              to="/problems"
              data-testid={`interested-item-${p.id}`}
              className="group block bg-white rounded-2xl p-5 ring-1 ring-[#F3F4F6] hover:ring-[#B8FFDD] transition-colors"
            >
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium bg-[#F3F4F6] text-[#4B5563]">
                      {p.category}
                    </span>
                    <span
                      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold ${URGENCY_STYLES[p.urgency]}`}
                    >
                      {p.urgency}
                    </span>
                  </div>
                  <p className="mt-2 font-display font-semibold text-[#111827] leading-snug">
                    {p.title}
                  </p>
                  <p className="mt-1 text-sm text-[#4B5563] line-clamp-2">
                    {p.description}
                  </p>
                  <p className="mt-2 inline-flex items-center gap-1.5 text-xs text-[#9CA3AF]">
                    <Users size={11} /> {p.interestedCount} interested · Posted
                    by {p.postedBy.name}
                  </p>
                </div>
                <ArrowUpRight
                  size={16}
                  className="text-[#9CA3AF] group-hover:text-[#3FFFB6] flex-shrink-0 mt-1"
                />
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
